module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$props.dealId) ? _c('div', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    staticClass: "z-deal-view"
  }, [_c('flex-tabs', {
    attrs: {
      "tabs": _vm.tabs,
      "min": true
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }), (_vm.activeTab == 'tab-customers') ? _c('div', {
    staticClass: "z-deal-view__list"
  }, [(_vm.deal.sender) ? _c('ZDealCustomerView', {
    staticClass: "z-deal-view__50",
    attrs: {
      "customer": _vm.deal.sender,
      "deal": _vm.deal,
      "type": "sender",
      "title": "Отправитель"
    }
  }) : _vm._e(), (_vm.deal.recipient) ? _c('ZDealCustomerView', {
    staticClass: "z-deal-view__50",
    attrs: {
      "customer": _vm.deal.recipient,
      "deal": _vm.deal,
      "type": "recipient",
      "title": "Получатель"
    }
  }) : _vm._e(), (_vm.deal.payer) ? _c('ZDealCustomerView', {
    staticClass: "z-deal-view__50",
    attrs: {
      "customer": _vm.deal.payer,
      "deal": _vm.deal,
      "type": "payer",
      "title": "Плательщик"
    }
  }) : _vm._e(), (_vm.deal.applicant) ? _c('ZDealCustomerView', {
    staticClass: "z-deal-view__50",
    attrs: {
      "customer": _vm.deal.applicant,
      "deal": _vm.deal,
      "type": "applicant",
      "title": "Составитель заявки"
    }
  }) : _vm._e()], 1) : _vm._e(), (_vm.activeTab == 'tab-freight') ? _c('ZFreightView', {
    attrs: {
      "freight": _vm.deal.first_freight
    }
  }) : _vm._e(), _c('ZFreightTracking', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.activeTab == 'tab-tracking')),
      expression: "(activeTab == 'tab-tracking')"
    }],
    attrs: {
      "deal": _vm.deal,
      "freight": _vm.deal.first_freight,
      "load": (_vm.activeTab == 'tab-tracking'),
      "block": true
    }
  }), (_vm.deal.id && _vm.activeTab == 'tab-comments') ? _c('comments-and-logs', {
    attrs: {
      "entity_id": _vm.deal.id,
      "entity": "deals",
      "module": "deals"
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea672f0e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZDealView.vue
// module id = 1272
// module chunks = 0